// extracted by mini-css-extract-plugin
module.exports = {"Gbook":"Gbook--32ko9","header":"header--3uIR_","headerLeft":"headerLeft--2WOUn","headerRight":"headerRight--zXNeC","content":"content--1Scws"};